import { createSlice } from '@reduxjs/toolkit';
import { DARK_THEME } from '../../utils/constants';

const getInitialTheme = () => {
  if (typeof window !== 'undefined' && window.localStorage) {
    const storedPrefs = window.localStorage.getItem('color-theme');
    if (typeof storedPrefs === 'string') {
      return storedPrefs;
    }

    const userMedia = window.matchMedia('(prefers-color-scheme: dark)');
    if (userMedia.matches) {
      return DARK_THEME;
    }
  }
  // If you want to use light theme as the default, return "light" instead
  return DARK_THEME;
};

const configSlice = createSlice({
  name: 'config',
  initialState: {
    theme: getInitialTheme(),
    showProfileModal: false,
  },
  reducers: {
    changeTheme: (state, actions) => {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem('color-theme', actions.payload);
      }
      state.theme = actions.payload;
    },
    setProfileModal: (state, actions) => {
      state.showProfileModal = actions.payload;
    },
  },
});

export const { changeTheme, setProfileModal } = configSlice.actions;
export default configSlice.reducer;
